<app-lista-dados
  [upTitulo]="'Agendamentos do Ponto Eletrônico'"
  [upIcone]="'alarm'"
  [upCor]="'1565C0'"
  [upDados]="agendamentos"
  [upColunas]="colunasListaDados"
  [upCarregando]="!!subscription"
  [upHabilitaEditarLinha]="true"
  [upLargura]="1"
  [upHabilitaContador]="true"
  [upHabilitaFiltroRapido]="false"
  [upAcoesLinha]="acoesLinha"
  [upTextoBotaoExcluir]="'Excluir'"
  [upIconeBotaoExcluir]="'delete'"
  (ueIniciarEdicaoLinha)="onIniciarEdicao($event)"
  (ueSalvarLinha)="onSalvarLinha($event)"
  (ueAcaoLinha)="executarAcaoLinha($event)"
  (ueBotaoExcluir)="onExcluir($event)">
</app-lista-dados>
